import { LoginService } from './../login.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { TwoFactorAuthService } from '@capturum/auth';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { LoginConfig } from '../login.config';
import { LoginConfigService } from '../login-config.service';
import { TranslateService } from '@ngx-translate/core';
import { tap } from 'rxjs/operators';
import { LoginAction } from '../base/login-action.enum';
import { CapturumInputCodeComponent } from '@capturum/ui/input-code';

@Component({
  selector: 'cap-two-factor',
  templateUrl: './two-factor.component.html',
  styleUrls: ['./two-factor.component.scss'],
})
export class TwoFactorComponent implements OnInit {
  public formGroup: FormGroup;
  public loginError: boolean;
  public config$: Observable<LoginConfig>;

  @ViewChild(CapturumInputCodeComponent)
  private inputCodeComponent: CapturumInputCodeComponent;

  public get controlMethod(): AbstractControl {
    return this.formGroup.get('method');
  }

  constructor(
    private configService: LoginConfigService,
    private route: ActivatedRoute,
    private twoFactorAuthService: TwoFactorAuthService,
    private formBuilder: FormBuilder,
    private translateService: TranslateService,
    private loginService: LoginService,
  ) {
    this.loginError = false;
  }

  public ngOnInit(): void {
    this.config$ = this.configService.getConfig().pipe(
      tap((config) => this.translateService.use(config.defaultLanguage)),
    );

    this.formGroup = this.generateForm();
  }

  private generateForm(): FormGroup {
    const { userId, method } = this.route.snapshot.queryParams;

    return this.formBuilder.group({
      key: [null, [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
      user_id: [userId, Validators.required],
      method: [method, Validators.required],
    });
  }

  public onSubmit(): void {
    this.loginError = false;

    this.twoFactorAuthService.login(this.formGroup.value).subscribe({
      next: response => {
        this.loginService.setAction(LoginAction.twoFA, true);
        this.loginService.onTwoFactorLoginSuccess(response);
      },
      error: error => {
        this.loginError = true;

        this.loginService.setAction(LoginAction.login, false, error.status);
        this.loginService.onTwoFactorLoginFail(error);

        this.inputCodeComponent.reset();
      },
    });
  }
}
